import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { NAV } from "@/lib/site";
import QuoteButton from "@/components/ui-kit/QuoteButton";
import MobileNav from "./MobileNav";
import NavItem from "./NavItem";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`sticky top-0 z-50 bg-white/90 backdrop-blur-xl border-b transition-[box-shadow,border-color] duration-300 ${scrolled ? "border-slate-200 shadow-[0_10px_40px_-20px_rgba(11,15,38,0.35)]" : "border-transparent"}`}
    >
      <div className={`max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between gap-6 transition-[height] duration-300 ${scrolled ? "h-16" : "h-20"}`}>
        <Link to="/" data-testid="header-logo-link" className="shrink-0">
          <img src="/brand/logo.png?v=2" alt="S4s Enterprises Pvt. Ltd." className={`w-auto transition-[height] duration-300 ${scrolled ? "h-12" : "h-[60px] sm:h-[68px]"}`} />
        </Link>
        <nav className="hidden lg:flex items-center gap-1" aria-label="Primary">
          {NAV.map((n) => <NavItem key={n.to} n={n} />)}
        </nav>
        <div className="flex items-center gap-3">
          <QuoteButton testId="nav-get-quote-button" className="hidden sm:inline-flex" small />
          <button data-testid="mobile-menu-toggle" onClick={() => setOpen(true)} aria-label="Open menu"
            className="lg:hidden w-11 h-11 grid place-items-center bg-[var(--navy)] text-white chamfer-sm active:scale-95 transition-transform">
            <Menu className="w-5 h-5" />
          </button>
        </div>
      </div>
      <MobileNav open={open} onClose={() => setOpen(false)} />
    </header>
  );
}
